<template>
  <StudioDialog primaryActionTitle="Close" @primaryAction="$emit('close')" @close="$emit('close')">
    <div class="tw-relative tw-flex tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden">
      <div class="tw-grow tw-px-5 tw-pb-5">
        <h1 class="tw-font-medium">Video in use</h1>
        <div class="tw-mt-1.5 tw-w-full tw-text-sm tw-leading-tight tw-text-slate-600">
          This video is currently in use in the following destinations and cannot be removed. Please remove the video
          from these destinations first to proceed.
          <div class="tw-mt-5 tw-max-h-[300px] tw-overflow-y-auto tw-pr-2">
            <div
              v-for="usage in usageData"
              :key="usage?.entity_id"
              class="tw-flex tw-w-full tw-items-center tw-justify-between tw-py-3"
            >
              <div>
                <div class="tw-text-sm tw-font-medium tw-text-black">{{ usage.entity_title }}</div>
                <div class="tw-mt-0.5 tw-text-xs tw-text-slate-600">
                  {{ usage.entity_subtype || transformVideoAssetUsageEntityType(usage) }}
                </div>
              </div>
              <div class="tw-flex tw-flex-col tw-items-end">
                <div
                  class="tw-flex tw-cursor-pointer tw-items-center tw-space-x-1 tw-text-sm hover:tw-underline"
                  @click="onUsageClick(usage)"
                >
                  <span class="tw-text-xs tw-font-medium tw-text-black">Visit</span>
                  <IconArrowUpRight class="tw-h-4 tw-w-4 tw-text-black" />
                </div>
                <div v-if="usage.entity_created_date" className="tw-mt-1 tw-text-xs tw-text-slate-600">
                  <span v-if="usage.entity_type === 'EVENT'">Event Date: </span>
                  <span v-else>Created: </span>
                  {{ formatDate(usage.entity_created_date) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </StudioDialog>
</template>

<script setup lang="ts">
import { VideoAssetUsage } from '@goldcast/api/backend';
import { IconArrowUpRight } from '@tabler/icons-vue';
import moment from 'moment';

import { redirectToUsage, transformVideoAssetUsageEntityType } from '../utils';

import StudioDialog from '@/studioComponents/StudioDialog.vue';

defineProps<{
  usageData: VideoAssetUsage[];
}>();

const formatDate = (date: string) => moment(date).format('MMM D, YYYY');

const onUsageClick = (usage: VideoAssetUsage): void => {
  redirectToUsage(usage);
};
</script>
